import { useState, useEffect } from 'react';
import { useParams, NavLink } from "react-router-dom";
import axios from 'axios'
import DescriptionListItem from '../components/DescriptionListItem'
import Loading from '../components/Loading';
import PageHeader from '../components/PageHeader';
import ResourceNotFound from '../components/ResourceNotFound';
import Swal from 'sweetalert2'
import Deleting from '../components/Deleting';

class toDisplay {
  constructor(oldContact, contactIfEmpty){ 
    const contact_with_italic_map = new Map();
    if (oldContact.length == 0) {
      contact_with_italic_map.set('contact',contactIfEmpty);
      contact_with_italic_map.set('italic',true);
    } 
      else {
        contact_with_italic_map.set('contact',oldContact);
        contact_with_italic_map.set('italic',false);
      }
    return contact_with_italic_map;
  }
}

const ProjectRead = () => {
  const [projectDetail, setProjectDetail] = useState(null)
  const [projectNotFound, setProjectNotFound] = useState(null)
  const [projectDeletingProgress, setProjectDeletingProgress] = useState(null)

  const [successMessage, setSuccessMessage] = useState("")
  const [errorMessages, setErrorMessages] = useState([])


  // Get the "tag" parameter from the URL
  const { tag: projectTag } = useParams()

  // When the component renders for the first time, load the data from API
  useEffect(() => {
    const callAPI = () => {
      axios({
        method: 'GET',
        url: `${process.env.REACT_APP_API_BASE_URL}/projects/${projectTag}`,
        headers: { 'content-type': 'application/json' },
      }).then(response => {
        setProjectDetail(response.data)
      }).catch(error => {
        console.error('error', error)
        if (error.response && error.response.status === 404) {
          setProjectNotFound(error.response.data)
        }
      });
    }
    callAPI()
  }, [projectTag])

  if (projectNotFound) {
    return <ResourceNotFound pageTitle="Project view" message={projectNotFound.Message} />
  }

  // React will try and render the component before the useEffect executes, so we need to handle
  // what to show when we don't yet have data to show
  if (projectDetail === null) {
    return <Loading pageTitle="Project view" />
  }

  if (projectDeletingProgress) {
    const { status } = projectDeletingProgress
    return <Deleting pageTitle={projectDetail.Project} inProgress={status === 'DELETING'} />
  }

  const accountIcon = (<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z" />
  </svg>)

  const poundIcon = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 9a2 2 0 10-4 0v5a2 2 0 01-2 2h6m-6-4h4m8 0a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>

  const securityIcon = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
  </svg>

  const serviceIcon = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
  </svg>

  const seviceListIcon = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2m-2-4h.01M17 16h.01" />
  </svg>

  const accounts = projectDetail.Accounts.map(account => {
    return {
      label: account,
      url: `/accounts/${account}`
    }
  })

  const convertStringToLabelObjForTable = item => {
    return { label: item }
  }

  const services = projectDetail.Services.map(svc => {
    return {
      label: svc.Name,
      url: `/services/${svc.Tag}`
    }
  })

  const billingContacts = projectDetail.BillingContacts.map(convertStringToLabelObjForTable)
  const serviceContacts = projectDetail.ServiceContacts.map(convertStringToLabelObjForTable)
  const securityContacts = projectDetail.SecurityContacts.map(convertStringToLabelObjForTable)

  // owner field
  const projectOwner = projectDetail.ProjectOwner.map(convertStringToLabelObjForTable)


  const handleDeleteProject = () => {
    setProjectDeletingProgress({ status: 'DELETING' })

    axios({
      method: 'DELETE',
      url: `${process.env.REACT_APP_API_BASE_URL}/projects/${projectTag}`,
      headers: { 'content-type': 'application/json' }
    }).then((response) => {
      setProjectDeletingProgress({ status: 'DELETED' })
      setErrorMessages([])
      setSuccessMessage(response.data.Message)
    }).catch(error => {
      console.error('error', error)
      setProjectDeletingProgress(null)
      setErrorMessages(error.response.data.errors)
    })
  }

  const deleteService = () => {
    Swal.fire({
      title: 'Let me double check!',
      text: `Do you really want to delete ${projectDetail.Project}?`,
      icon: 'warning',
      confirmButtonText: 'Delete',
      showCloseButton: true,
      buttonsStyling: false,
      allowEnterKey: false,
      customClass: {
        confirmButton: 'hover:bg-red-700 text-white px-3 py-2 rounded-md text-sm font-medium bg-red-500'
      }
    }).then(res => {
      const { isConfirmed } = res
      if (isConfirmed) {
        return handleDeleteProject()
      }
    })
  }

  const editButton = (<NavLink className="hover:bg-indigo-700 hover:text-white px-3 py-2 rounded-md text-sm font-medium bg-gray-100 block" to={`/projects/edit/${projectTag}`}>
    Edit
  </NavLink>)

  const deleteButton = (<button className="hover:bg-red-700 text-white px-3 py-2 rounded-md text-sm font-medium bg-red-500" type="button" onClick={deleteService}>
    Delete
  </button>)

  const billingContactstoDisplay = new toDisplay(billingContacts,projectOwner);
  const serviceContactstoDisplay = new toDisplay(serviceContacts,projectOwner);
  const securityContactstoDisplay = new toDisplay(securityContacts,projectOwner);

  // if (billingContacts.length == 0) {
  //   billingContactstoDisplay = projectDetail.ProjectOwner.map(convertStringToLabelObjForTable)} 
  //   else {billingContactstoDisplay = projectDetail.BillingContacts.map(convertStringToLabelObjForTable)}
  // if (securityContacts.length == 0) {
  //   securityContactstoDisplay = projectDetail.ProjectOwner.map(convertStringToLabelObjForTable)} 
  //   else {securityContactstoDisplay = projectDetail.SecurityContacts.map(convertStringToLabelObjForTable)}
  // if (serviceContacts.length == 0) {
  //   serviceContactstoDisplay = projectDetail.ProjectOwner.map(convertStringToLabelObjForTable)} 
  //   else {serviceContactstoDisplay = projectDetail.ServiceContacts.map(convertStringToLabelObjForTable)}


  return (
    <>
      {/* Page Header */}
      <PageHeader title={projectDetail.Project} buttons={[editButton, deleteButton]} />


      {/* Container */}
      <div className="container mt-10 flex">
        <div className="w-1/3">
          <div className="pr-5">
            <div className="text-lg font-bold tracking-normal text-gray-900">Project information</div>
            <div className="text-gray-600 mt-1">This is all the information about the project. You can click through to connected accounts and the parent project.</div>
          </div>

        </div>
        {/* Form in white box */}

        <div className="w-2/3 bg-white rounded-lg box-border shadow-md">
          {/* SuccessMessage */}

          {successMessage && (<div className="p-8">
            <div className="rounded bg-green-500 text-white text-base p-4">
              {successMessage}
            </div></div>
          )}
          {errorMessages.length > 0 && (<div className="p-8">
            <div className="rounded bg-red-500 text-white text-base p-4">
              {errorMessages}
            </div></div>
          )}
          <DescriptionListItem label="Project name:" value={projectDetail.Project} />
          <DescriptionListItem label="Billing reference:" value={projectDetail.BillingRef} />
          <DescriptionListItem label="Tag:" value={projectDetail.Tag} />
          <DescriptionListItem label="Billing contacts:" value={{ type: "table", icon: poundIcon, items: billingContactstoDisplay.get('contact'), italic: billingContactstoDisplay.get('italic')}} />
          <DescriptionListItem label="Security contacts:" value={{ type: "table", icon: securityIcon, items: securityContactstoDisplay.get('contact'), italic: securityContactstoDisplay.get('italic')}} />
          <DescriptionListItem label="Service contacts:" value={{ type: "table", icon: serviceIcon, items: serviceContactstoDisplay.get('contact'), italic: serviceContactstoDisplay.get('italic')}} />
          <DescriptionListItem label="Accounts:" value={{ type: "table", icon: accountIcon, items: accounts }} />
          <DescriptionListItem label="Services:" value={{ type: "table", icon: seviceListIcon, items: services }} />
          <DescriptionListItem label="Project Owner:" value={{ type: "table", icon: securityIcon, items: projectOwner }} />
        </div>
      </div>
    </>
  );
}

export default ProjectRead;